import { Injectable } from '@angular/core';
import { sustentosModulo } from 'src/app/aplicaciones-modulos/sustentos/diccionarios/sustentosModulo';
import { Observable } from 'rxjs';
import { ResponseExportacionModel } from "../models/responseExportacionModel";
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Injectable({
    providedIn: 'root'
})

export class ExportarService {

    urlSustentos: string;
    diccionarioUrl: any;
  
    constructor(private commom: CommonService,
      private utilServices: UtilsService) {
      this.urlSustentos = this.utilServices.getSustentos();
      this.diccionarioUrl = sustentosModulo.url.sustentos;
    }

    getAllExportacion(): Observable<ResponseExportacionModel[]> {
        return this.commom.peticionGetConHeader(this.urlSustentos + this.diccionarioUrl.exportacion);
    }

    postExportar(data:any) {
        return this.commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.exportacion, data);
    }

    getExportaDownload(fichero: string): Observable<any> {
        return this.commom.peticionGetConHeader(this.urlSustentos + this.diccionarioUrl.getExportacionDownload + fichero);
    }
    
}